import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MessageService, ConfirmationService } from 'primeng/api';
import { Component, OnInit, Input, EventEmitter, Output, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AlertService } from '@app/_services';
import * as moment from 'moment';
import { PrimeNGConfig } from 'primeng/api';
import { OrderProductTaxJoinService } from '../order-product-tax-join.service';
import { OrderProductTaxJoin } from '../order-product-tax-join';
import { PropertyService } from '@app/_components/property/property.service';
import { OrderProductService } from '@app/_components/order-product/order-product.service';
import { OrderTaxService } from '@app/_components/order-tax/order-tax.service';

@Component({
    selector: 'app-order-product-tax-join',
    templateUrl: './order-product-tax-join.component.html',
    styleUrls: ['./order-product-tax-join.component.css'],
    providers: [MessageService, ConfirmationService],
    standalone: false
})
export class OrderProductTaxJoinComponent implements OnInit {
	orderProductId: any;
	orderProducts: any[]=[];
	orderTaxes: any[]=[];
	orderProductTaxFlag = false;
	readOnlyFlag = false;
	orderTaxId: any;
	targetProperties: any[]=[];
	sourceProperties: any[]=[];
	isDataLoaded = false;
	orderProductTaxJoins: any[]=[];
	isSearching = false;
	orderProductTaxIds: any[]=[];
	orderProductObj: any[]=[];

	constructor(
		private primengConfig: PrimeNGConfig,
		private orderProductTaxJoinService: OrderProductTaxJoinService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private orderProductService: OrderProductService,
		private orderTaxService: OrderTaxService,
		private formBuilder: UntypedFormBuilder,
		private propertyService: PropertyService,
		@Inject(MAT_DIALOG_DATA) data: any) {
		this.formTitle = data.title,
			this.orderProductTaxJoin = data?.orderProductTaxJoin,
			this.orderProductId = data?.orderProductId,
			this.orderProductTaxFlag = data?.orderProductTaxFlag,
			this.statuses = orderProductTaxJoinService.statuses;
			if(this.orderProductId == undefined){
				this.orderProductId = this.orderProductTaxJoin?.orderProductId;
			}
	}

	@Input() orderProductTaxJoin: OrderProductTaxJoin;
	@Output() doAdd = new EventEmitter<any>();
	@Output() doUpdate = new EventEmitter<any>();
	@Output() doDelete = new EventEmitter<any>();

	// data
	orderProductTaxJoinId: number;

	// forms
	form1: UntypedFormGroup;
	formLoading = false;
	formAlert: String;
	formTitle: String;

	statuses: any;

	validationMessages = {
		'orderProductId': [{ type: 'required', message: 'Required' }],
		'orderTaxId': [{ type: 'required', message: 'Required' }],
	};

	ngOnInit() {
		this.primengConfig.ripple = true;
		this.formBuild();
		// this.fetchProperties();
		this.fetchOrderTaxes();
		this.fetchOrderProducts();

		// if we were passed the whole orderProductTaxJoin object
		if (this.orderProductTaxJoin) {
			this.readOnlyFlag = true;
			this.orderProductTaxJoinId = this.orderProductTaxJoin.orderProductTaxJoinId;
			this.orderTaxId = this.orderProductTaxJoin.orderTaxId;
			this.fixDates();
			this.form1.patchValue(this.orderProductTaxJoin);
		}
	}

	fetchProperties() {
			try {
				this.propertyService.findAllSummary()
					.subscribe(
						res => {
							// console.log('findAllPropertiesSummary: ' + JSON.stringify(res));
							// this.properties = res.data.properties;
							
							// return this.properties;
						},
						err => {
							console.log('Feature-Update FAIL: ' + JSON.stringify(err));
							this.alertService.error(err);
						},
						() => { });
			} catch (error) {
				console.log('Form Invalid: ' + JSON.stringify(error));
				this.alertService.error(error);
			}
	}

	fetchOrderProducts() {
			try {
				this.orderProductService.findAllOrderProducts()
					.subscribe(
						res => {
							// console.log('findAllPropertiesSummary: ' + JSON.stringify(res));
							this.orderProducts = res.data.orderProducts;
							return this.orderProducts;
						},
						err => {
							console.log('Feature-Update FAIL: ' + JSON.stringify(err));
							this.alertService.error(err);
						},
						() => { });
			} catch (error) {
				console.log('Form Invalid: ' + JSON.stringify(error));
				this.alertService.error(error);
			}
	}

	fetchOrderTaxes() {
		try {
			this.orderTaxService.findAllOrderTaxes()
				.subscribe(
					res => {
						// console.log('findAllPropertiesSummary: ' + JSON.stringify(res));
						this.orderTaxes = res.data.taxs;
						this.fetchOrderProductTaxJoinByOrderProductId();
					},
					err => {
						console.log('Feature-Update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
}

fetchOrderProductTaxJoinByOrderProductId() {
	if(this.orderProductId){
		try {
			this.orderProductTaxJoinService.getAllByOrderProductId(this.orderProductId)
				.subscribe(
					res => {
						// console.log('findAllPropertiesSummary: ' + JSON.stringify(res));
						this.orderProductTaxJoins = res.data.orderProductTaxJoins;
						// this.isDataLoaded = false;
						this.targetProperties = [];
						this.sourceProperties = [];
						
						this.orderTaxes.forEach(orderTax => {
							const orderProductHaveProperty = this.orderProductTaxJoins.find((e: any) => e.orderTaxId == orderTax.orderTaxId);
							if(orderProductHaveProperty != null) {
								this.targetProperties.push(orderTax);
							}else{
								this.sourceProperties.push(orderTax);
							}
						});
						this.isDataLoaded = true;
						this.primengConfig.ripple = true;
						
						// return this.orderProductShortTermRentalJoins;
					},
					err => {
						console.log('Feature-Update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}else{
		this.sourceProperties = this.orderTaxes;
		this.isDataLoaded = true;
	}
}

	onFormDelete() {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + this.orderProductTaxJoinId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete()
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}

	formAdd() {
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			console.log('property-add post: ' + JSON.stringify(this.form1.value));
			this.formLoading = true;
			this.orderProductTaxJoinService.add(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-add SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.orderProductTaxJoin = res.data.orderProductTaxJoin;
						this.doAdd.emit(this.orderProductTaxJoin);
					},
					(err: any) => {
						console.log('orderProductTaxJoin-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error) {
			this.alertService.error(error);
		}
	}

	formUpdate() {
		console.log('orderProductTaxJoin: ' + JSON.stringify(this.form1.value));
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			this.formLoading = true;

			this.orderProductTaxJoinService.update(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-update SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.orderProductTaxJoin = res.data.orderProductTaxJoin;
						this.doUpdate.emit(this.orderProductTaxJoin);
					},
					(err: any) => {
						console.log('property-update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	formDelete() {
		try {
			this.orderProductTaxJoinService.deleteOrderProductTaxRelationship(this.orderProductId, this.orderProductTaxJoin.orderProductTaxJoinId)
				.subscribe(
					(res: any) => {
						console.log('orderProductTaxJoin-delete SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.doDelete.emit(this.orderProductTaxJoin);
					},
					(err: any) => {
						console.log('orderProductTaxJoin-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			this.alertService.error(error);
		}
	}

	formBuild() {
		this.form1 = this.formBuilder.group({
			orderProductId: [this.orderProductId, Validators.required],
			orderTaxId: [],
		});
	}

	fixDates() {
		// create date objects - why can't primeng do this?
		this.orderProductTaxJoin.orderProductTaxJoinDate = moment(this.orderProductTaxJoin.orderProductTaxJoinDate).toDate();
	}

	moveAllToTarget(event: any){ 
		this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
		this.orderProductObj = [];
		event.items.forEach(orderProductTaxJoin => {
			const dataObj = {
				"orderProductId":this.orderProductId,
				"orderTaxId":orderProductTaxJoin.orderTaxId,
			}
			this.orderProductObj.push(dataObj)
		});
		this.formAddOrderProductShortTermRentalJoin(this.orderProductObj);
    }

	moveToTarget(event: any){ 
		this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
		this.orderProductObj = [];
		event.items.forEach(orderProductTaxJoin => {
			const dataObj = {
				"orderProductId":this.orderProductId,
				"orderTaxId":orderProductTaxJoin.orderTaxId,
			}
			this.orderProductObj.push(dataObj)
		});
		this.formAddOrderProductShortTermRentalJoin(this.orderProductObj);
    } 

	moveAllToSource(event: any){ 
		this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
		this.orderProductTaxIds = [];
		event.items.forEach(orderProductTax => {
			this.orderProductTaxIds.push(orderProductTax.orderTaxId)
		});
		this.deleteOrderProductTaxsRelationship(this.orderProductTaxIds);
    } 
    moveToSource(event: any){ 
		this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
		this.orderProductTaxIds = [];
		event.items.forEach(orderProductTax => {
			this.orderProductTaxIds.push(orderProductTax.orderTaxId)
		});
		this.deleteOrderProductTaxsRelationship(this.orderProductTaxIds);
    }

	deleteOrderProductTaxsRelationship(orderProductTaxIds: any[]) {
		this.isSearching = true;
		try {
			this.orderProductTaxJoinService.deleteOrderProductTaxsRelationship(this.orderProductId, orderProductTaxIds)
				.subscribe(
					(res: any) => {
						this.isSearching = false;
						// console.log('orderProductShortTermRentalJoin-delete SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: "Successfully move into Available Units" });
						this.doUpdate.emit(null);
						this.doAdd.emit(null);
					},
					(err: any) => {
						this.isSearching = false;
						console.log('orderProductShortTermRentalJoin-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => {  });
		} catch (error) {
			this.isSearching = false;
			this.alertService.error(error);
		}
	}

	formAddOrderProductShortTermRentalJoin(orderProductObj: any[]) {
		this.isSearching = true;
		try {
			this.orderProductTaxJoinService.addAll(orderProductObj)
				.subscribe(
					(res: any) => {
						this.isSearching = false;
						console.log('property-add SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: "Successfully move into Selected Units" });
						this.doUpdate.emit(null);
						this.doAdd.emit(null);
					},
					(err: any) => {
						this.isSearching = false;
						console.log('orderProductShortTermRentalJoin-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => {  });

		} catch (error) {
			this.isSearching = false;
			this.alertService.error(error);
		}
	}

	setOrderProductId(event: any){
		this.orderProductId = event.value;
		this.fetchOrderProductTaxJoinByOrderProductId();
	}
}
